<template>
  <div class="app-container" ref="body">
    <div class="app-body">
      <van-nav-bar
        title="学籍缴费"
        left-text="返回"
        left-arrow
        fixed
        class="fixedapp"
        @click-left="goBack(roll.stuid ? '/stu-main/'+ roll.stuid : '/')"
      />
      <van-pull-refresh
        v-model="isLoading"
        success-text="刷新成功"
        @refresh="onRefresh"
        style="min-height:calc(100vh - 50px);"
      >
        <van-cell-group title="学籍信息">
          <van-cell>
            <div>
              <p><van-tag :color="rollStatusColor(roll.status)">{{ xjStatus[roll.status] ? xjStatus[roll.status].name : roll.status }}</van-tag> {{ roll.xjname }} / {{ roll.ccname || '未定层次' }} </p>
              <p>{{ roll.zyname || '未定专业' }} / {{ roll.yxname || '未定院校' }}</p>
            </div>
          </van-cell>
        </van-cell-group>
        <van-cell-group title="缴费信息">
          <van-cell>
            <div>
              <p>应缴费：<van-tag>{{ showPrice(roll.total) }}</van-tag></p>
              <p>已缴费：<van-tag type="success">{{ showPrice(roll.amount - roll.reamount) }}</van-tag></p>
              <div class="d-flex mt-1">
                <van-button type="primary" round plain icon="plus" @click.stop="addPay()">在线缴费</van-button>
                <!-- <div v-if="(roll.total - roll.amount - roll.reamount) > 0" class="mr-1">
                </div> -->
                <!-- <div v-if="!roll.amount || roll.amount <= 0">
                  <van-button color="#7232dd" round plain icon="plus" @click.stop="$refs.cyj.show(1)" style="white-space:nowrap;">缴纳预报名费</van-button>
                </div> -->
              </div>
            </div>
          </van-cell>
        </van-cell-group>
        <van-cell-group title="缴费单">
          <template v-for="item in feeList">
            <van-cell :key="item.id" class="roll-item">
              <div>
                <p>缴费单号：{{ item.code }}</p>
                <p v-if="item.jfname">缴费名称：{{ item.jfname }}</p>
                <p>缴费金额：<van-tag type="success">{{ showPrice(item.amount - item.reamount) }}</van-tag></p>
                <p>缴费时间：{{ item.feetime }}</p>
                <p>缴费状态：{{ item.wxorder ? (orderStatus[item.wxorderstatus] || item.wxorderstatus) : '线下缴费' }}</p>
                <!-- <p>单据状态：<van-tag :color="feeStatusColor(item.status)">{{ feeStatus[item.status] }}</van-tag></p> -->
                <div v-if="item.status == 8" style="margin-top:5px;">
                  <van-button type="primary" round block @click.stop="payAgain(item)">在线支付</van-button>
                </div>
              </div>
            </van-cell>
          </template>
        </van-cell-group>
      </van-pull-refresh>
    </div>
    <van-action-sheet v-model="show" title="在线缴费" class="fixedapp">
      <div style="padding:1rem;">
        <!-- {{settings}} -->
        <van-image :src="payImg"></van-image>
      </div>
      <!-- <van-form class="pay-form" @submit="submitPay">
        <van-cell title="支付方式">
          <div>
            微信支付
          </div>
        </van-cell>
        <van-cell title="待缴费">
          <div>
            <van-tag color="#7232dd" style="padding:2px 4px; font-size:1.3rem;">{{ showPrice(roll.total - roll.amount - roll.reamount) }}</van-tag>
          </div>
        </van-cell>
        <van-field
          v-model="form.amount"
          :readonly="changeAmount"
          type="number"
          name="amount"
          label="缴费金额"
          placeholder="输入缴费金额"
          :rules="[{ required: true, message: '请输入正确的缴费金额' }]"
          input-align="right"
          clearable
          class="pay-amount-input"
        />
        <div class="signup-btns">
          <van-button round block type="info" native-type="submit" :loading="saveLoading" loading-text="支付中...">
            确定支付
          </van-button>
        </div>
      </van-form> -->
    </van-action-sheet>
    <FeeCyj :roll="roll" ref="cyj" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from 'jystore/mutation-types';
import siteMixin from '@/utils/site-mixin';
import { feeStatusColor } from '../global';
import { deepCopy } from '@/utils/utils';
import FeeCyj from './stu-fee-cyj';
export default {
  components: {
    FeeCyj
  },
  mixins: [siteMixin],
  props: {
    id: String,
    feeid: String,
    add: {
      type: Boolean,
      default: false
    },
    action: String
  },
  data() {
    return {
      error: false,
      isLoading: false,
      roll: {},
      feeList: [],
      saveLoading: false, 
      show: false,
      showKeybord: false,
      form: {},
      showPay: false,
      showYbm: false,
    }
  },
  computed: {
    ...mapGetters({
      'settings': 'settings',
      reloadWeb: [types.OTHER.reloadWeb],
      xjList: [types.BASE_LOAD.xjList],
      xjStatus: [types.BASE_LOAD.xjStatus],
      orderStatus: [types.STATUS.orderStatus],
      feeStatus: [types.STATUS.feeStatus],
    }),
    changeAmount() {
      return this.feeid ? true : false;
    },
    payImg() {
      return (this.settings?.clientfeeqrcode) ? this.imgPath(this.settings.clientfeeqrcode) : this.imgLocal('pay.jpg?t=20240731');
    }
  },
  watch: {
    reloadWeb() {
      this.loadData();
    },
  },
  created() {
    this.loadData();
  },
  activated () {
    this.showPay = false;
    this.showYbm = false;
    const val = this.action;
    if (val) {
      this.showPay = false;
      this.showYbm = false;
      if (val == 'pay') {
        this.showPay = true;
        if (this.roll && this.roll.id) {
          this.addPay();
        }
      } else if (val == 'ybm') {
        this.showYbm = true;
        if (this.roll && this.roll.id) {
          this.$refs.cyj.show(1);
        }
      }
    }
  },
  methods: {
    loadData(callback) {
      if (!this.xjList || !this.xjList.length) {
        this.$store.dispatch(types.BASE_LOAD.xjList);
      }
      if (!this.xjStatus || !Object.keys(this.xjStatus).length) {
        this.$store.dispatch(types.BASE_LOAD.xjStatus);
      }
      if (!this.orderStatus || !Object.keys(this.orderStatus).length) {
        this.$store.dispatch(types.STATUS.orderStatus);
      }
      if (!this.feeStatus || !Object.keys(this.feeStatus).length) {
        this.$store.dispatch(types.STATUS.feeStatus);
      }
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      this.doPost({
        url: 'site/fee/'+ this.id,
        data: {},
        okcb: (json) => {
          if (callback && callback instanceof Function) {
            callback(json);
          } else {
            this.setData(json);
          }
        },
        cb: () => {
          this.$nextTick(() => this.isLoading = false);
        },
        errcb: () => {
          this.error = true;
        }
      });
    },
    setData(json) {
      this.roll = Object.assign({}, json.roll);
      this.feeList = json.feeList || [];

      if (this.feeid) {
        let fees = this.feeList.filter(d => d.id == this.feeid);
        if (fees.length) {
          this.payAgain(fees[0]);
        }
      }
      if (this.add || this.action == 'pay') {
        this.addPay();
      } else if (this.action == 'ybm') {
        this.$refs.cyj.show(1);
      }
      if (this.showPay) {
        this.addPay();
      }
      if (this.showYbm) {
        this.$refs.cyj.show(1);
      }
    },
    feeStatusColor(status) {
      return feeStatusColor(status);
    },
    onRefresh() {
      this.isLoading = false;
      this.loadData((json) => {
        this.setData(json);
        this.$toast('刷新成功');
      });
    },
    addPay() {
      this.show = true;
      this.$set(this.form, 'amount', this.showPrice(this.roll.total - this.roll.amount - this.roll.reamount));
    },
    submitPay() {
      let postData = deepCopy(this.roll);

      postData.amount = this.form.amount * 100;
      postData.openid = this.member.openid;
      postData.paymethod = 'WX';
      postData._member = {id:this.member.id};
      postData.version === null ? postData.version = 1 : (postData.version += 1);

      this.Toast.loading({
        message: '加载中...',
        forbidClick: true
      });

      this.saveLoading = true;
      this.doPost({
        url: 'site/fee/submit',
        data: postData,
        okcb: (json) => {
          // 如果需要公众号openid
          if (json.needopenid) {
            setTimeout(() => {
              this.login();
            }, 100);
            return;
          }

          let params = { goods: {name: this.roll.xjname, amount: this.form.amount * 100}, orderid: this.roll.stuid };
          if (json.code_url) {
            params.codeUrl = json.code_url;
          } else {
            params.wxpayparams = JSON.parse(json.payparams);
          }
          // 支付界面
          this.$router.push({ name:'signup-pay', params: params });
        },
        cb: () => {
          this.saveLoading = false;
          this.Toast.clear();
        },
        errcb: (json) => {
          if (json && json.message) {
            setTimeout(() => {
              this.Toast.fail(json.message);
            }, 10);
          }
        }
      });
    },
    payAgain(data) {
      // 如果未登录，或缺失openid【微信浏览器中】，则登录
      if (!this.member.id || !this.member.openid) {
        this.login();
        return;
      }
      let amount = this.showPrice(data.total - data.amount - data.reamount);
      this.Toast.loading({
        message: '加载中...',
        forbidClick: true
      });
      this.doPost({
        url: 'site/fee/wxpay2/'+ data.id,
        data: {openid: this.member.openid},
        okcb: (json) => {
          // 如果需要登录获取openid
          if (json.needopenid) {
            this.login();
            return;
          }
          if (json.ok) {
            setTimeout(() => {
              this.Toast('已完成支付！');
            }, 20);
            data.status = json.status;
            data.wxorderstatus = json.wxorderstatus;
            return;
          }
          let params = { goods: { name: this.roll.xjname, amount: amount }, orderid: this.roll.stuid };
          if (json.code_url) {
            params.codeUrl = json.code_url;
          } else {
            params.wxpayparams = JSON.parse(json.payparams);
          }
          // 支付界面
          this.payforward = true;
          this.$router.push({ name:'signup-pay', params: params });
        },
        cb: () => {
          this.Toast.clear();
        },
        errcb: (json) => {
          if (json && json.message) {
            setTimeout(() => {
              this.Toast.fail(json.message);
            }, 10);
          }
        }
      });
    }
  }
}
</script>
<style lang="less" scoped>
.app-body {
  padding-top:46px;
  padding-bottom:10px;
  min-height:calc(100vh - 56px);
  background-color:#f5f5f5;
}
.pay-form {
  /deep/ .van-field__error-message{
    text-align:right;
  }
  /deep/ .pay-amount-input{
    /deep/ .van-field__control {
      font-size:1.4rem;
    }
  }
  .signup-btns{
    padding:5px 10px;
  }
}
.roll-item{
  padding:1rem;
  background-color:#fff;
}
.roll-item::before {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 2px;
  background: -webkit-repeating-linear-gradient(135deg, #ff6c6c 0, #ff6c6c 20%, transparent 0, transparent 25%, #1989fa 0, #1989fa 45%, transparent 0, transparent 50%);
  background: repeating-linear-gradient(-45deg, #ff6c6c 0, #ff6c6c 20%, transparent 0, transparent 25%, #1989fa 0, #1989fa 45%, transparent 0, transparent 50%);
  background-size: 80px;
  content: '';
}
</style>